import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
export function getUserEntitlementsFromNetwork(correlationId, getIdentity, inMockMode, officeHomeApiRoot, workload, getAccessToken, jwtAuthEnabled) {
    return __awaiter(this, void 0, void 0, function () {
        var requestConfig, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestConfig = {
                        method: "GET" /* HttpRequestMethod.Get */,
                        responseType: "json" /* HttpResponseContentType.Json */,
                        url: "".concat(officeHomeApiRoot, "/api/userEntitlements"),
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, inMockMode, workload, getIdentity)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, httpGet(KnownInstrumentationEvents.UserEntitlementsRequest, "UserEntitlements" /* KnownRequestInstrumentationEvents.UserEntitlementsRequest */, requestConfig.url, requestConfig, jwtAuthEnabled, getAccessToken, officeHomeApiRoot, correlationId, 'OfficeHome', {})];
                case 3:
                    data = (_b.sent()).data;
                    if (data) {
                        return [2 /*return*/, data];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, null];
            }
        });
    });
}
//# sourceMappingURL=getUserEntitlementsFromNetwork.js.map